<template>
  <div v-if="inputedValue.dialog && pageData.length > 0">
    <PaymentDialogBase
      v-model="inputedValue"
      :title="title"
      :width="width"
      :pageData="pageData"
      :currencyId="recItems.currencyId"
      :exchangeGainLoss="exchangeGainLoss"
      paymentType="order"
      isCardColor="true"
      @register="register"
      @cancel="cancel"
    >
      <template v-slot:[pageData[2].name]>
        <ClientInfo :recItems="recItems" />
      </template>
      <template v-slot:[pageData[3].name]>
        <OperationDetail :recItems="recItems" type="order" />
      </template>
    </PaymentDialogBase>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import PaymentDialogBase from './PaymentDialogBase'

import headersHistory from '@/views/order/History/headers'
import ClientInfo from '@/components/layouts/ClientConfirmation/SpplierInfo/SpplierInfoBase'
import OperationDetail from '@/components/layouts/OperationDetail/OperationDetail'
import { orderUtil, commonUtil } from '@/util'
import { BigNumber } from 'bignumber.js'

export default {
  components: {
    PaymentDialogBase,
    ClientInfo,
    OperationDetail
  },
  props: {
    value: { default: false },
    width: { default: '540px' },
    title: { default: 'storage.storage_payment-operation' },
    recItems: {
      type: Object,
      require: true,
      default: () => ({})
    }
  },
  data: () => ({
    pageData: [],

    recDetail: {
      productListHeaders: headersHistory.productListHeaders
    },
    exchangeGainLoss: ''
  }),
  async created() {
    // await this.ini()
  },

  methods: {
    ...mapActions('Order', [
      'getOrderPaymentListFromApi',
      'registerOrderPayment',
      'cancelOrderPayment'
    ]),
    ...mapActions('Common', ['setIsLoading']),
    getAmount() {
      // 合計金額
      return orderUtil.calcOrderAmountById(this.recItems.orderId)
    },
    getPayAmount(paymentList) {
      // 出金済金額
      return paymentList.data.reduce((sum, ele) => {
        return sum + Number(ele.amount)
      }, 0)
    },
    async ini() {
      const paymentList = await this.getOrderPaymentListFromApi({
        id: this.recItems.orderId
      })

      const amount = commonUtil.formatPrice(this.getAmount())
      const payAmount = commonUtil.formatPrice(this.getPayAmount(paymentList))
      const notPayAmount = BigNumber(amount).minus(payAmount).toNumber()

      this.pageData = [
        {
          title: 'storage.storage_payment-exe',
          name: 'paymentInfo',
          items: [
            {
              name: 'payment.payment_total-price-no-colon',
              data: amount
            },
            {
              name: 'storage.storage_not-payment-price-no-colon',
              data: notPayAmount
            },
            { name: 'storage.storage_payment-date' },
            { name: 'storage.storage_payment-price' },
            {
              name: 'storage.storage_payment-method',
              component: 'SelectPaymentMethod'
            },
            { name: 'storage.storage_payment-method-register' },
            { name: 'storage.storage_payment-exe' }
          ],
          data: {
            id: this.recItems.orderId,
            date: '',
            method: {},
            notPayAmount: notPayAmount
          },
          itemKey: ''
        },
        {
          title: 'sale.sale_payment-history',
          name: 'paymentHistory',
          buttonName: 'sale.sale_payment-cancellation',
          itemKey: 'orderPaymentId',
          headers: [
            {
              text: 'storage.storage_payment-date',
              value: 'date',
              sortable: false,
              width: '12%'
            },
            {
              text: 'storage.storage_payment-price',
              value: 'amount',
              sortable: false,
              width: '12%',
              align: 'end'
            },
            {
              text: 'storage.storage_payment-method',
              value: 'paymentMethodId',
              sortable: false,
              width: '12%'
            },
            {
              text: 'payment.payment_operation',
              value: 'operationId',
              sortable: false
            }
          ],
          items: paymentList.data,
          footers: [
            {
              name: 'storage.storage_already-payment-price-no-colon',
              data: payAmount
            },
            {
              name: 'payment.payment_total-price-no-colon',
              data: amount
            },
            {
              name: 'storage.storage_not-payment-price-no-colon',
              data: notPayAmount
            }
          ]
        },
        {
          title: 'order.order_supplier-info',
          name: 'spplierInfo'
        },
        {
          title: 'order.order_order-detail',
          name: 'orderDetail'
        }
      ]
    },
    async register() {
      this.setIsLoading(true)
      const isConfirmed = confirm(this.$t('ship.ship_ship-save-question'))
      if (isConfirmed) {
        const isSucceed = await this.registerOrderPayment(this.pageData[0].data)
        if (isSucceed) {
          alert(this.$t('common.common_saved-alert'))
          this.$emit('complete')
          // this.inputedValue.dialog = false
        }
      }
      this.setIsLoading(false)
    },
    async cancel(id) {
      const isConfirmed = confirm(
        this.$t('order.order_confirm-to-order-payment')
      )
      if (isConfirmed) {
        const isSucceed = await this.cancelOrderPayment(id)
        if (isSucceed) {
          alert(this.$t('common.common_canceled-alert'))
          this.$emit('complete')
          // this.inputedValue.dialog = false
        }
      }
    },
    async getExchangeGainLoss() {
      if (
        !this.pageData ||
        !this.pageData[0].data.notPayAmount ||
        !this.pageData[0].data.date
      )
        return

      const registerDateFxRate = await commonUtil.getFxRate(
        this.recItems.orderDate
      )
      const inputDateFxRate = await commonUtil.getFxRate(
        this.pageData[0].data.date
      )

      const registerDateExchangedPrice = commonUtil.exchangePriceByFxRate(
        this.recItems.currencyId,
        this.getUserInfoFromState.organization.currencyId,
        this.pageData[0].data.notPayAmount,
        registerDateFxRate
      )
      const inputDateExchangedPrice = commonUtil.exchangePriceByFxRate(
        this.recItems.currencyId,
        this.getUserInfoFromState.organization.currencyId,
        this.pageData[0].data.notPayAmount,
        inputDateFxRate
      )
      this.exchangeGainLoss = commonUtil.formatPrice(
        registerDateExchangedPrice - inputDateExchangedPrice
      )
    }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    },
    ...mapGetters('User', ['getUserInfoFromState'])
  },
  watch: {
    inputedValue: {
      deep: true,
      async handler(newVal, oldVal) {
        if (newVal.dialog) await this.ini()
      }
    },
    pageData: {
      deep: true,
      handler() {
        this.getExchangeGainLoss()
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
